<template>
  <div class="nav-contianer">
    <AppLink
      class="nav-link"
      active-class="nav-active"
      inactive-class="nav-inactive"
      to="/home"
    >
      首页
    </AppLink>
    <AppLink
      class="nav-link"
      active-class="nav-active"
      inactive-class="nav-inactive"
      to="/products"
    >
      服务
    </AppLink>
    <AppLink
      class="nav-link"
      active-class="nav-active"
      inactive-class="nav-inactive"
      to="/articles"
    >
      必读
    </AppLink>
    <AppLink
      class="nav-link"
      active-class="nav-active"
      inactive-class="nav-inactive"
      to="/activitys"
    >
      活动
    </AppLink>
    <AppLink
      class="nav-link"
      active-class="nav-active"
      inactive-class="nav-inactive"
      to="/aboutUs"
    >
      <a-dropdown>
        <div>公司介绍</div>
        <a-menu slot="overlay">
          <a-menu-item
            key="0"
            @click="goView('/aboutUs')"
            style="display: flex; align-items: center"
          >
            <img
              src="../assets/shanhaimap.svg"
              alt="law-firm"
              class="law-firm-img mr-20"
            />
            <a target="_blank" rel="noopener noreferrer">山海图</a>
          </a-menu-item>
          <a-menu-item
            key="1"
            @click="goView('/LawFirm')"
            style="display: flex; align-items: center"
          >
            <img
              src="../assets/ic_ls.svg"
              alt="law-firm"
              class="law-firm-img mr-20"
            />
            <a target="_blank" rel="noopener noreferrer"
              >泛亚律所(SEA LAW FIRM)</a
            >
          </a-menu-item>

          <a-menu-item
            key="2"
            @click="goView('/TaxFirm')"
            style="display: flex; align-items: center"
          >
            <img
              src="../assets/ic_sws.svg"
              alt="tax-firm"
              class="tax-firm-img mr-20"
            />
            <a target="_blank" rel="noopener noreferrer"
              >SHM TAX CONSULTING(税务所)</a
            >
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </AppLink>
  </div>
</template>

<script>
import AppLink from '@/components/AppLink.vue'
export default {
  name: 'Nav',
  components: {
    AppLink
  },
  methods: {
    goView(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped lang="less">
@import url("@/variable.less");
.nav-link {
  display: inline-block;
  height: @header-height;
  line-height: @header-height;
  font-size: 16px;
  font-weight: 400;
  color: #333;
  margin-right: 56px;
  padding: 0 4px;
}
.nav-active {
  color: #2223eb;
  position: relative;
  font-weight: bold;
  &::after {
    content: " ";
    width: 100%;
    height: 2px;
    position: absolute;
    left: 0;
    bottom: 0;
    background-color: #2223eb;
  }
}
.nav-inactive:hover {
  color: #2223eb;
}
</style>
